import React from 'react'
import { Checkbox, ControlLabel } from 'gu-ui-kit'
import { useSelector } from 'react-redux'

const renderCheckbox = ({
  input,
  meta: { touched, submitting, error, form } = {},
  required: requiredProp,
  ...rest
}) => {
  const requiredFromSchema = useSelector(
    (state) => state['forms/meta']?.[form]?.[input.name] ?? false,
  )
  const required = requiredProp ?? requiredFromSchema

  return (
    <>
      <ControlLabel
        {...input}
        {...rest}
        checked={rest.checked}
        label={rest.label}
        error={touched && error}
        onChange={(event) => input.onChange(!!event.currentTarget.checked)}
        hidden={!!rest.hidden || rest.type === 'hidden'}
        disabled={submitting || rest.disabled}
        required={required}
        control={<Checkbox />}
      />
    </>
  )
}

export default renderCheckbox
